import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction, IRequestExecutionContext, IResponseExecutionContext } from "@/Common/Stores/Actions/BaseAction";

class PatientPortalManagementActions extends BaseAction {
    constructor(onBeforeExecute?: IRequestExecutionContext, onBeforeHandleResponse?: IResponseExecutionContext) {
        super(onBeforeExecute, onBeforeHandleResponse);
    }

    // -------------------------------------------------------------------------------------------------------------------------
    // - portal mgmgt ----------------------------------------------------------------------------------------------------------
    // -------------------------------------------------------------------------------------------------------------------------

    public loadPortalAccountOverview(patientId: string): void {
        if (typeof patientId !== "undefined" && patientId !== null && patientId !== "") {
            this.Execute(ServerOperations.Server.Portal_Proxy_GetPatientPortalProfileOverview, { PatientContactId: patientId });
        }
    }

    public subscription_get(patientContactId: string): void {
        this.Execute(ServerOperations.Server.Portal_Proxy_GetSubscription, {
            PatientContactId: patientContactId
        });
    }

    public subscription_create(patientId: string, planId: string, intervalId: number, startDate: Date): void {
        this.Execute(ServerOperations.Server.Portal_Proxy_CreateSubscription, {
            PatientId: patientId,
            SubscriptionPlanId: planId,
            PaymentInterval: intervalId,
            StartDate: MyleHelper.GetStandardizedDateString(startDate)
        });
    }

    public subscription_changeManagedAccounts(subscriptionPatientId: string, addedMemberMyleId: string, subscriptionId: string, isRemoval: boolean): void {
        let requestData = {
            PatientId: subscriptionPatientId,
            AddedMemberMyleId: addedMemberMyleId,
            IsRemove: isRemoval,
            SuscriptionId: subscriptionId
        };

        this.Execute(ServerOperations.Server.Portal_Proxy_Subscription_ChangeManagedAccounts, requestData);
    }

    public subscription_makePayment(transactionIds: string[], subscriptionId: string, balance: number): void {
        let requestData = {
            transactionIds: transactionIds,
            subscriptionId: subscriptionId,
            balance: balance
        };

        this.Execute(ServerOperations.Server.Portal_Proxy_Subscription_MakePayment, requestData);
    }

    public account_get(patientContactId: string): void {
        this.Execute(ServerOperations.Server.Portal_Proxy_GetAccount, {
            PatientContactId: patientContactId
        });
    }

    public account_updateAccountRegistrationState(patientContactId: string): void {
        this.Execute(ServerOperations.Server.Portal_Proxy_PatientRegistered, {
            Id: patientContactId
        });
    }

    public loadCustomerPaymentInfo(patientId: string): void {
        if (typeof patientId !== "undefined" && patientId !== null && patientId !== "") {
            this.Execute(ServerOperations.Server.Portal_Proxy_GetPaymentCustomer, { PatientContactId: patientId });
        }
    }
}

export { PatientPortalManagementActions };
